import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { formatDateTime } from '../../../helpers'
import DOMPurify from 'dompurify';
import CloseIcon from '@mui/icons-material/CloseRounded';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailReadRounded';
import EmailIcon from '@mui/icons-material/EmailRounded';
import AccountTreeIcon from '@mui/icons-material/AccountTreeRounded';

export default function AutoreplyDetailsModal(props) {
    const [data, setData] = useState(props.data)
    
    const [aIdetails, setAIDetails] = useState()
    
    const rawMarkup = (content) => {
        var rawMarkup = content
        return { __html: DOMPurify.sanitize(rawMarkup) };
    }
    
    const makeAIDetails = () => {
        const ufc = (s) => {
            return s[0].toUpperCase() + s.substr(1) 
        }
        
        const details = props.data?.details ?? {}
            
        const ls = {
            'country': '',
            'spam': '',
            'name': '',
            'development': '',
            'sites': '',
            'topic': '',
            'links': '',
            'time': '',
        }
        
        let answer = []
        for (let key in ls) {
            if (key === 'sites') {
                if (details.sites) {
                    answer.push('<b>Sites:</b>')
                    answer.push('<table cellspacing="1" cellpadding="10" bgcolor="#dddddd">')
                    for (let i in details.sites) {
                        answer.push('<tr>')
                        answer.push('<td bgcolor="#ffffff">' + details.sites[i].name + '</td>')
                        answer.push('<td bgcolor="#ffffff">' + details.sites[i].description + '</td>')
                        let linksShort = []
                        details.sites[i].links.forEach((o) => {linksShort.push(o.name)})
                        answer.push('<td bgcolor="#ffffff">' + (linksShort.length ? linksShort.join(', ') : 'none') + '</td>')
                        answer.push('</tr>')
                    }
                    answer.push('</table>')
                }
            } else
            if (key === 'links') {
                if (details.links) {
                    answer.push('<b>Links:</b>')
                    for (let i in details.links) {
                        answer.push(details.links[i].similarity)
                        answer.push('<i><b>' + details.links[i].name + '</b></i>: <u>' + details.links[i].url + '</u><br>' + details.links[i].description + '<br>')
                    }
                }
            } else {
                if (details[key]) {
                    answer.push('<b>' + ufc(key) + ':</b> ' + details[key])
                }
            }
        }
        
        setAIDetails(answer.join("\n"))
    }
    
    useEffect(() => {
        makeAIDetails()
    }, [props.data])
        
    return (
        <Dialog open={props.data ? true : false} onClose={() => {props.onClose()}} fullWidth maxWidth="md" >
            <DialogTitle id="alert-dialog-title">
                Email Details
                {props.data?.details?.spam == 'yes' ? 
                (<b> (SPAM)</b>)
                : null}
                <IconButton
                    onClick={props.onClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1} sx={{pb:6}}>
                    <Grid item md={12} xs={12}>
                        <b>From:</b> {props.data?.input_from}
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <b>Received At:</b> {formatDateTime(props.data?.created_at)}
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <b>Country:</b> {props.data?.country || <b>(no country)</b> }
                    </Grid>
                    {props.data?.sent_at ?
                    <Grid item md={4} xs={12}>
                        <b>Sent At:</b> {formatDateTime(props.data?.sent_at)}
                    </Grid>
                    : null }
                    <Grid item md={12} xs={12}>
                        <b>Subject:</b> {props.data?.input_subject || <b>(no subject)</b> }
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <Stack>
                            <b>Content:</b>
                            <Alert
                                icon={<EmailIcon sx={{color: '#555555'}} />}
                                sx={{whiteSpace: 'pre-line', backgroundColor: '#eeeeee', mt:0.5}}
                            >
                                {props.data?.input_content || <b>(no content)</b> }
                            </Alert>
                        </Stack>
                    </Grid>
                    {props.data?.output_content ?
                    <Grid item md={12} xs={12}>
                        <Stack>
                            <b>Response:</b>
                            <Alert
                                icon={<MarkEmailReadIcon sx={{color: '#555555'}} />}
                                severity="warning"
                                sx={{whiteSpace: 'pre-line', mt:0.5}}
                            >
                                {props.data?.output_content}
                            </Alert>
                        </Stack>
                    </Grid>
                    : null }
                    
                    {aIdetails ?
                    <Grid item md={12} xs={12}>
                        <Stack>
                            <b>Processing Log:</b>
                            <Alert 
                                severity="info"
                                icon={<AccountTreeIcon sx={{color: '#555555'}} />}
                                sx={{whiteSpace: 'pre-line', mt:0.5}}
                            >
                                <div dangerouslySetInnerHTML={rawMarkup(aIdetails)} />
                            </Alert>
                        </Stack>
                    </Grid>
                    : null }
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {props.onClose()}}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}